const _excluded = ["className", "description", "disabled", "hovered", "id", "invalid", "label", "target", "wrap"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import classNames from 'clsx';
import { AlignBox } from "../Align";
import Box from "../Box";
import { Body, BodyAlt, BodyAltTextProps } from "../Text";
const PressableControlLabel = props => {
  const {
      className,
      description,
      disabled = false,
      hovered = false,
      id,
      invalid = false,
      label,
      target,
      wrap = true
    } = props,
    remaining = _objectWithoutProperties(props, _excluded);
  const getLabelColor = () => {
    if (disabled) {
      return 'disabled';
    } else if (invalid) {
      return 'invalid';
    }
    return hovered ? 'dark' : 'default';
  };
  const classes = classNames('PressableControlLabel', className);
  const hasCopy = label || description;
  const Wrapper = hasCopy ? AlignBox : Box;
  const wrapperProps = hasCopy ? {
    reference: BodyAltTextProps
  } : {};
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    className: classes
  }, wrapperProps), target, hasCopy ? /*#__PURE__*/React.createElement(Box, {
    padding: {
      left: 8
    }
  }, label ? /*#__PURE__*/React.createElement(BodyAlt, {
    color: getLabelColor(),
    wrap: wrap
  }, /*#__PURE__*/React.createElement("label", _extends({}, remaining, {
    className: "PressableControlLabel-label",
    htmlFor: id
  }), label)) : null, description ? /*#__PURE__*/React.createElement(Body, {
    color: "gray"
  }, description) : null) : null);
};
export default PressableControlLabel;